import { useSelector } from 'react-redux';
import { campaignsSelector, hydratedSelector } from '../ducks/selectors';

import Carousel from '~/components/carousel/carousel-async';

const CasinoCarousel = () => {
	const isHydrated = useSelector(hydratedSelector);
	const campaigns = useSelector(campaignsSelector);

	return <Carousel campaigns={campaigns} isHydrated={isHydrated} />;
};

export default CasinoCarousel;
